import {Rules} from "just-validate";

export const lang = document.querySelector('html').getAttribute('lang')
export const dictionary = [
    {
        key: Rules.Required,
        dict: {
            'da-DK': 'Feltet er påkrævet.',
            'kl-GL': 'Qeqqarsimavoq takkuaq.'
        }
    },
    {
        key: Rules.Email,
        dict: {
            'da-DK': 'E-mail har ugyldigt format.',
            'kl-GL': 'E-mail imassuteqarfiup saannaassalliinnut.'
        }
    },
    {
        key: Rules.Integer,
        dict: {
            'da-DK': 'Feltet må kun indholde tal.',
            'kl-GL': 'Atorfik illoqarfiup qeqqarsimavoq ilisimasaq.'
        },
    },
    {
        key: 'user_create_conditions',
        dict : {
            'da-DK' : 'Du skal acceptere betingelserne for at oprette din bruger.',
            'kl-GL' : 'Brugereniit pingasunngortoqartarput aallartinneqarput.'
        }
    },
    {
        key: 'notification_conditions',
        dict: {
            'da-DK' : 'Du skal acceptere betingelserne.',
            'kl-GL' : 'Qanorittaaffigineqarpit.'
        }
    },
    {
        key: 'Passwords should be the same',
        dict : {
            'da-DK' : 'Kodeord skal være de samme.',
            'kl-GL' : 'Kodamik ullumi suliniarpoq.',
        }
    },
    {
        key: 'password_strengh_very_bad',
        dict: {
            'da-DK' : 'Meget svag',
            'kl-GL' : 'Aammalu unnuaq'
        }
    },
    {
        key: 'password_strengh_bad',
        dict: {
            'da-DK' : 'Svag',
            'kl-GL' : 'Unnuaq'
        }
    },
    {
        key: 'password_strengh_medium',
        dict: {
            'da-DK' : 'Medium',
            'kl-GL' : 'Ortaarpoq'
        }
    },
    {
        key: 'password_strengh_strong',
        dict: {
            'da-DK' : 'Stærk',
            'kl-GL' : 'Immikkoorpoq'
        }
    },
    {
        key: 'password_strengh_error',
        dict: {
            'da-DK' : 'Stærk',
            'kl-GL' : 'Immikkoorpoq'
        }
    },
]